// frontend/src/slices/orderSlice.js - Clean version without discounts

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for creating order (clean version)
export const createOrder = createAsyncThunk(
    'order/create',
    async (orderData) => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        // Clean order items without discount information
        const cartItems = orderData.orderItems.map(item => ({
            product: item.product,
            name: item.name,
            price: item.price,
            image: item.image,
            quantity: item.quantity,
            priceType: item.priceType,
            selectedWeight: item.selectedWeight,
            dozenPrice: item.dozenPrice,
            packPrice: item.packPrice,
            finalPrice: item.finalPrice || item.price
        }));

        const response = await axios.post('/api/v1/order/new', {
            ...orderData,
            orderItems: cartItems
        }, config);

        return response.data;
    }
);

const orderSlice = createSlice({
    name: 'order',
    initialState: {
        loading: false,
        orders: [],
        error: null,
        orderDetails: null
    },
    reducers: {
        ordersRequest(state) {
            state.loading = true;
        },
        ordersSuccess(state, action) {
            state.loading = false;
            state.orders = action.payload;
        },
        ordersFail(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        clearErrors(state) {
            state.error = null;
        },
        setOrderDetails(state, action) {
            state.orderDetails = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createOrder.pending, (state) => {
                state.loading = true;
            })
            .addCase(createOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.orders = [...state.orders, action.payload];
            })
            .addCase(createOrder.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const {
    ordersRequest,
    ordersSuccess,
    ordersFail,
    clearErrors,
    setOrderDetails
} = orderSlice.actions;

export default orderSlice.reducer;